import { render } from "./CustomAreaLegend.vue?vue&type=template&id=8b902f4a&scoped=true"
import script from "./CustomAreaLegend.vue?vue&type=script&lang=js"
export * from "./CustomAreaLegend.vue?vue&type=script&lang=js"

import "./CustomAreaLegend.vue?vue&type=style&index=0&id=8b902f4a&scoped=true&lang=css"
import "./CustomAreaLegend.vue?vue&type=style&index=1&id=8b902f4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b902f4a"]])

export default __exports__